import {
  FormControlLabel,
  Grid,
  Input,
  InputAdornment,
  List,
  ListItem,
  ListItemSecondaryAction,
  Radio,
  RadioGroup,
  useMediaQuery,
} from '@material-ui/core';
import { useFormikContext } from 'formik';
import { AssuranceIcon } from 'images';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { POLICY_TO_REPLACE } from 'utils/globalConst';
import {
  ErrorTitle,
  PrimaryTitleCard,
  StyledListItemText,
  StyledSecondaryTitle,
  useStyles,
} from './styles';
interface FoldersListProps {
  titleCard: string;
  activeSearch?: boolean;
  radioButtonName: string;
  FoldersListItems: {
    name: string;
    label: string;
    icon?: any;
    secondTitle?: string;
  }[];
}
const FoldersList = ({
  FoldersListItems,
  titleCard,
  activeSearch,
  radioButtonName,
}: FoldersListProps) => {
  const classes = useStyles();
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const [items, setItems] = React.useState<
    FoldersListProps['FoldersListItems']
  >(FoldersListItems);
  const lang = useSelector(getLocaleSelector);
  const intl = useIntl();
  /* istanbul ignore next */
  const searchItems = (searchValue: string) => {
    const filtredData = FoldersListItems.filter((item) => {
      return Object.values(item)
        .join('')
        .toLowerCase()
        .includes(searchValue.toLowerCase());
    });
    setItems(filtredData);
  };
  React.useEffect(() => {
    setItems(FoldersListItems);
  }, [FoldersListItems]);

  const showPolicyIndication: any = () => {
    const policy = POLICY_TO_REPLACE?.find(
      (d) =>
        items?.find((p: any) => p.name === d.newPolicy) ||
        items?.find((p: any) => p.name === d.oldPolicy),
    );
    if (radioButtonName === 'organisme' && policy) {
      return policy;
    }
    return null;
  };

  const getPolicyLabel = (policy: any) => {
    const label = items?.find((d: any) => d.name === policy)?.label || '';
    return label;
  };

  const { setFieldValue, values, errors } = useFormikContext<any>();
  /* istanbul ignore next */
  return (
    <>
      <Grid style={{ padding: 10 }}>
        <PrimaryTitleCard style={{ marginBottom: 10 }} fontSize="16px">
          {titleCard}
        </PrimaryTitleCard>
        <ErrorTitle>
          {errors[radioButtonName] && errors[radioButtonName]}
        </ErrorTitle>
        {showPolicyIndication() && (
          <StyledSecondaryTitle variant="body2">
            <FormattedMessage
              id={'dm.policy.choice.to.replace'}
              values={{
                date: showPolicyIndication().maxDate,
                oldPolicy: `"${getPolicyLabel(
                  showPolicyIndication().oldPolicy,
                )}"`,
                newPolicy: `${getPolicyLabel(
                  showPolicyIndication().newPolicy,
                )}"`,
              }}
            />
          </StyledSecondaryTitle>
        )}
        {activeSearch && (
          <Input
            placeholder={intl.formatMessage({ id: 'map_filter.research' })}
            className={classes.inputTextStyle}
            disableUnderline={true}
            onChange={
              /* istanbul ignore next */ (e) => searchItems(e.target.value)
            }
            startAdornment={
              <InputAdornment position="start">
                <img
                  style={{ marginLeft: 8 }}
                  src={AssuranceIcon.searchIcon}
                  alt="search icon - saham assurance"
                />
              </InputAdornment>
            }
          />
        )}
      </Grid>
      <List
        dir={'ltr'}
        style={{ maxHeight: isNotMobile ? 230 : 300, overflow: 'auto' }}
        className={classes.root}
      >
        <RadioGroup
          name={radioButtonName}
          value={values[radioButtonName]}
          onChange={(event) => {
            /* istanbul ignore next */
            setFieldValue(radioButtonName, event.currentTarget.value);
          }}
        >
          {items.map((value) => (
            <ListItem
              dir={'ltr'}
              key={value.name}
              role={undefined}
              dense
              style={{
                background: '#FFFFFF',
                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
                borderRadius: '6px',
                marginBottom: 10,
              }}
            >
              <FormControlLabel
                style={{
                  paddingLeft: lang === LANGUAGES.FR ? 10 : 0,
                }}
                value={value.name}
                dir={'ltr'}
                label={
                  <>
                    <Grid
                      style={{
                        marginLeft: 10,
                        alignItems: 'flex-start',
                      }}
                      container
                      direction="column"
                    >
                      <StyledListItemText primary={value.label} />
                      {value.secondTitle && (
                        <StyledSecondaryTitle variant="body2">
                          {value.secondTitle}
                        </StyledSecondaryTitle>
                      )}
                    </Grid>

                    {value.icon && (
                      <ListItemSecondaryAction
                        style={
                          lang === LANGUAGES.AR ? { right: 10 } : { right: 0 }
                        }
                      >
                        <img
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 10,
                            marginLeft: 10,
                          }}
                          src={AssuranceIcon[value.icon]}
                          alt=""
                        />
                      </ListItemSecondaryAction>
                    )}
                  </>
                }
                control={
                  <Radio
                    edge="start"
                    tabIndex={-1}
                    classes={{
                      root: classes.radio,
                      checked: classes.checked,
                    }}
                    size="small"
                  />
                }
              />
            </ListItem>
          ))}
        </RadioGroup>
      </List>
    </>
  );
};
export default FoldersList;
